import {AxiosInstance} from 'axios';

export interface CertificatePayload {
  blockchain_response: string;
  cap_hash_payload: string;
  cap_payload: string;
  issuer_address: string;
  payload: string;
  verified: boolean;
  public_key: string;
  revoked: boolean;
}

export interface Certificate {
  data: CertificatePayload | null;
  verifiedByAuthority: boolean;
}

export class Verify {
  private readonly instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  /**
   * Verify certificate by ID
   * @param {string} id
   * @return {Promise<any>}
   */
  public verifyCertificate(id: string): Promise<Certificate> {
    const URL = `/verify/${id}`;
    return new Promise((resolve, reject) => {
      // reject if token is empty
      if (!id || id.trim() === '') {
        reject({
          code: 'EMPTY_CERTIFICATE_ID',
          message: 'Certificate ID can not be empty'
        });
        return;
      }

      const config = {};

      this.instance.get(URL, config)
        .then((res: any) => {
          if (res.data.length === 0) {
            resolve({
              data: null,
              verifiedByAuthority: false,
            });
            return;
          }

          resolve({
            data: res.data[0],
            verifiedByAuthority: true,
          });
        })
        .catch((err) => {
          resolve({
            data: null,
            verifiedByAuthority: false,
          });
        });
    });
  }
}
